/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import ProductInputDisplay from '../../../products/ProductInputDisplay';
import { INPUT_CONTROL_TYPE_ENUM } from '../../../../../config/constants';
import { getDesignItemPropertiesObjectFromList } from '../../../designer/helpers/fabricCanvasHelper';
import { sanitizeText } from '../../../../../helpers/format';

const WsVariantPickerDesignInput = ({
  input,
  inputAnswer,
  onChange,
  disabled,
  baseStoreUrl,
  onNavigate
}) => {
  const { text, positionLabel, itemProperties: itemPropertiesList } =
    input || {};

  const itemProperties = getDesignItemPropertiesObjectFromList(
    itemPropertiesList
  );

  return (
    <ProductInputDisplay
      baseStoreUrl={baseStoreUrl}
      disabled={disabled}
      ecomVendorProductInput={{
        label: `${itemProperties.inputLabel || text} (${positionLabel})`,
        fkRegFormControlType: INPUT_CONTROL_TYPE_ENUM.TEXT_INPUT,
        isRequired: itemProperties.isRequired
      }}
      onChange={(value, type, previewImage) => {
        const sanitizedText = sanitizeText(value, {
          removeLetters: itemProperties.noLetters,
          removeNumbers: itemProperties.noNumbers,
          removeSpecialCharacters: itemProperties.noSpecialCharacters,
          removeSpaces: itemProperties.noSpaces,
          textTransform: itemProperties.textTransform,
          characterLimit: itemProperties.characterLimit
        });

        onChange(sanitizedText, type, previewImage);
      }}
      onNavigate={onNavigate}
      radius={0}
      value={inputAnswer?.value || ''}
    />
  );
};

WsVariantPickerDesignInput.propTypes = {
  baseStoreUrl: PropTypes.string,
  disabled: PropTypes.bool,
  input: PropTypes.object,
  inputAnswer: PropTypes.object,
  onChange: PropTypes.func,
  onNavigate: PropTypes.func
};

export default WsVariantPickerDesignInput;
